import { store as agendas } from './agendas'

const modules = {
  agendas
}

export default {
  namespaced: true,
  modules
}



// WEBPACK FOOTER //
// ./src/app/patient/store.js